import {
  textBody,
  textBodyLarge,
  textBodyUppercase,
  textCaption,
  textUppercaseBig,
  textUppercaseCaption,
} from '../../../../growth-platform-brand-system-v2/src/styles/typography';

const applyFilledColor = (color: string, isDark: boolean) => {
  switch (color) {
    case 'azur':
      return isDark
        ? 'bg-azur-101 text-neutral-1'
        : 'bg-azur-21 text-azur-101 border-neutral-1';
    case 'coral':
      return isDark
        ? 'bg-coral-101 text-neutral-1'
        : 'bg-coral-21 text-coral-101 border-neutral-1';
    case 'mint':
      return isDark
        ? 'bg-mint-101 text-neutral-1'
        : 'bg-mint-21 text-mint-101 border-neutral-1';
    case 'neutral':
      return isDark
        ? 'bg-neutral-101 text-neutral-1'
        : 'bg-neutral-21 text-neutral-101 border-neutral-1';
    case 'purple':
      return isDark
        ? 'bg-purple-101 text-neutral-1'
        : 'bg-purple-21 text-purple-101 border-neutral-1';
    case 'yellow':
      return isDark
        ? 'bg-yellow-101 text-neutral-1'
        : 'bg-yellow-21 text-yellow-101 border-neutral-1';
    case 'blue':
    default:
      return isDark
        ? 'bg-blue-101 text-neutral-1'
        : 'bg-blue-21 text-blue-101 border-neutral-1';
  }
};

const applyOutlinedColor = (color: string, isDark: boolean) => {
  switch (color) {
    case 'azur':
      return isDark
        ? 'text-azur-101 border-azur-101'
        : 'text-azur-21 border-azur-21';
    case 'coral':
      return isDark
        ? 'text-coral-101 border-coral-101'
        : 'text-coral-21 border-coral-21';
    case 'mint':
      return isDark
        ? 'text-mint-101 border-mint-101'
        : 'text-mint-21 border-mint-21';
    case 'neutral':
      return isDark
        ? 'text-neutral-101 border-neutral-101'
        : 'text-neutral-21 border-neutral-21';
    case 'purple':
      return isDark
        ? 'text-purple-101 border-purple-101'
        : 'text-purple-21 border-purple-21';
    case 'yellow':
      return isDark
        ? 'text-yellow-101 border-yellow-101'
        : 'text-yellow-21 border-yellow-21';
    case 'blue':
    default:
      return isDark
        ? 'text-blue-101 border-blue-101'
        : 'text-blue-21 border-blue-21';
  }
};

export const applyColor = (color: string, type: string, isDark: boolean) => {
  switch (type) {
    case 'filled':
      return applyFilledColor(color, isDark);
    case 'outlined':
      return applyOutlinedColor(color, isDark);
    default:
      return 'bg-blue-101 text-neutral-1';
  }
};

export const applySize = (size: string, isUppercase: boolean) => {
  let textStyle = textUppercaseBig;

  switch (size) {
    case 'big':
      textStyle = isUppercase ? textUppercaseBig : textBodyLarge;

      return `px-16 ${textStyle} h-40 border-2`;
    case 'mid':
      textStyle = isUppercase ? textBodyUppercase : textBody;

      return `px-12 ${textStyle} h-32 border-2`;
    case 'small':
      textStyle = isUppercase ? textUppercaseCaption : textCaption;

      return `px-8 ${textStyle} h-24 border`;
    default:
      textStyle = isUppercase ? textBodyUppercase : textBody;

      return `px-12 ${textStyle} h-32`;
  }
};

export const applyRadius = (isSquared: boolean) =>
  isSquared ? 'rounded-6' : 'rounded-full';
